import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { API_URL } from "../config";
import Calculators from "./Calculators";

export default function Tools() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = e => {
    setFile(e.target.files[0]);
    setResult(null);
    setError("");
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!file) return;
    setLoading(true);
    setError("");
    setResult(null);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await fetch(`${API_URL}/upload/pdf`, {
        method: "POST",
        body: formData,
      });

      const contentType = res.headers.get("content-type") || "";

      if (!res.ok) {
        // Бэкенд вернул ошибку в JSON
        let detail = "Ошибка обработки PDF";
        if (contentType.includes("application/json")) {
          const data = await res.json();
          detail = data.error || data.detail || detail;
        }
        throw new Error(detail);
      }

      // Успех: получаем PDF как blob и инициируем скачивание
      const blob = await res.blob();
      const downloadName = `anon_${file.name}`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = downloadName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setResult({ filename: downloadName, size: blob.size });
    } catch (err) {
      setError(err.message || "Ошибка загрузки PDF");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section>
      <h1 className="section-title">Инструменты</h1>
      <div className="card">
        <h3 style={{ color: "#007c84", marginTop: 0 }}>Анонимизация PDF</h3>
        <p style={{ color: "#555", fontSize: "0.95rem", marginBottom: 14 }}>
          Загрузите PDF-файл — из него будут удалены метаданные (автор, программа,
          дата создания и т.п.). Очищенный файл скачается автоматически.
        </p>
        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", marginBottom: 12 }}>
            <input type="file" accept="application/pdf" onChange={handleFileChange} />
          </label>
          <button type="submit" disabled={loading || !file}>
            {loading ? "Обработка…" : "Анонимизировать и скачать"}
          </button>
        </form>

        {result && (
          <div style={{ marginTop: "1em", color: "#0d7a3a", display: "flex", alignItems: "flex-start", gap: 6 }}>
            <CheckCircle2 size={16} strokeWidth={2.2} style={{ marginTop: 2, flexShrink: 0 }} />
            <span>Файл готов: <b>{result.filename}</b> ({Math.round(result.size / 1024)} КБ) — скачивание началось.</span>
          </div>
        )}
        {error && <div style={{ color: "#d9534f", marginTop: "1em" }}>{error}</div>}
      </div>

      <Calculators />
    </section>
  );
}
